var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"online_rate"},[_c('dec-block-title',[_vm._v(" 在线率TOP5(%)")]),_c('dv-charts',{staticStyle:{"cursor":"pointer"},attrs:{"option":_vm.option},nativeOn:{"click":function($event){return _vm.handleClick.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }